import { ConfirmDeleteTarget } from "models/ConfirmDeleteTarget";
import { MeetingDetailModel } from "models/MeetingDetailModel";
import { createContext } from "react";

export interface MeetingContextProps {
  meetingId: number | undefined;
  meeting: MeetingDetailModel | undefined;
  isLoading: boolean;
  reloadMeeting: () => Promise<void>;
  selectMeetingId: number | undefined;
  setSelectMeetingId: (id: number) => void;
  confirmDeleteMeeting: ConfirmDeleteTarget | undefined;
  setConfirmDeleteMeeting: (target: ConfirmDeleteTarget | undefined) => void;
  isMeetingExpanded: (id: number, defaultValue?: boolean) => boolean;
  toggleMeetingExpanded: (id: number) => void;
  setMeetingExpanded: (id: number, newState: boolean) => void;
  isMeetingUpdating: (id: number) => boolean;
  setMeetingUpdating: (id: number, newState: boolean) => void;
  isMeetingDeleting: (id: number) => boolean;
  setMeetingDeleting: (id: number, newState: boolean) => void;
}

export const MeetingContext = createContext({} as MeetingContextProps);
